import { Enum_Feature_Type_Enum } from "../generated/graphql"
import SleepIcon from "../assets/SleepIcon.svg"
import DrivingIcon from "../assets/DrivingIcon.svg"
import MotionIcon from "../assets/MotionIcon.svg"
import HomeIcon from "../assets/HomeIcon.svg"
import CommunicationsIcon from "../assets/CommunicationsIcon.svg"
import InsightsIcon from "../assets/InsightsIcon.svg"

import SleepIconMVP2 from "../assets/alertsAndBadges/sleep.svg"
import DrivingIconMVP2 from "../assets/alertsAndBadges/driving.svg"
import MotionIconMVP2 from "../assets/alertsAndBadges/activation.svg"
import HomeIconMVP2 from "../assets/alertsAndBadges/home.svg"
import CommunicationsIconMVP2 from "../assets/alertsAndBadges/friends.svg"
import InsightsIconMVP2 from "../assets/alertsAndBadges/insights.svg"

export const getIcon = (
  userInsightFeature?: Enum_Feature_Type_Enum,
  isMvp2?: boolean
) => {
  if (!userInsightFeature) return
  let image
  switch (userInsightFeature) {
    case Enum_Feature_Type_Enum.AmtSleepDayMin:
      image = isMvp2 ? SleepIconMVP2 : SleepIcon
      break
    case Enum_Feature_Type_Enum.AmtStationaryDayMin:
      image = isMvp2 ? MotionIconMVP2 : MotionIcon
      break
    case Enum_Feature_Type_Enum.AmtWalkingDayMin:
      image = isMvp2 ? MotionIconMVP2 : MotionIcon
      break
    case Enum_Feature_Type_Enum.AmtExerciseDayMin:
      image = isMvp2 ? MotionIconMVP2 : MotionIcon
      break
    case Enum_Feature_Type_Enum.AmtAutomotiveDayMin:
      image = isMvp2 ? DrivingIconMVP2 : DrivingIcon
      break
    case Enum_Feature_Type_Enum.NCharDay:
      image = isMvp2 ? CommunicationsIconMVP2 : CommunicationsIcon
      break
    case Enum_Feature_Type_Enum.NWordDay:
      image = isMvp2 ? CommunicationsIconMVP2 : CommunicationsIcon
      break
    case Enum_Feature_Type_Enum.PropGpsDayHome:
      image = isMvp2 ? HomeIconMVP2 : HomeIcon
      break
    case Enum_Feature_Type_Enum.PropWordAbsDay:
      image = isMvp2 ? CommunicationsIconMVP2 : CommunicationsIcon
      break
    case Enum_Feature_Type_Enum.PropWordIDay:
      image = isMvp2 ? CommunicationsIconMVP2 : CommunicationsIcon
      break
    case Enum_Feature_Type_Enum.PropWordNegDay:
      image = isMvp2 ? CommunicationsIconMVP2 : CommunicationsIcon
      break
    case Enum_Feature_Type_Enum.PropWordPosDay:
      image = isMvp2 ? CommunicationsIconMVP2 : CommunicationsIcon
      break
    case Enum_Feature_Type_Enum.ValBedtimeOffsetHour:
      image = isMvp2 ? SleepIconMVP2 : SleepIcon
      break
    case Enum_Feature_Type_Enum.ValEnjoyment:
    case Enum_Feature_Type_Enum.ValGrowth:
    case Enum_Feature_Type_Enum.ValMorningness:
    case Enum_Feature_Type_Enum.ValWaketimeOffsetHour:
      image = isMvp2 ? SleepIconMVP2 : SleepIcon
      break
    case Enum_Feature_Type_Enum.NotApplicable:
      image = isMvp2 ? InsightsIconMVP2 : InsightsIcon
      break
    default:
      image = ""
  }

  return image
}
